import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { IApiParams } from '../../interface/IApiParams';
import { getApiVersion } from '../../utils/utils';
import { getApi } from '../getApi';

export const apiGetSetup = async (id: string) => {
  const apiVersion = getApiVersion();
  const params: IApiParams = {
    url: `/setup/getSetup${apiVersion}.php?id=${id}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
